<script lang="ts" setup>
  import { onMounted, useTemplateRef } from 'vue';

  const toast = useTemplateRef<HTMLElement>('toast');

  onMounted(() => toast.value?.showPopover());
</script>

<template>
  <div ref="toast" class="connection-lost" popover="manual" role="status">
    <span aria-hidden="true" class="ring" />
    Connection lost. Reconnecting
  </div>
</template>

<style scoped>
  .connection-lost {
    align-items: center;
    backdrop-filter: blur(12px);
    background: var(--color-surface-frosted);
    border: 1px solid var(--color-primary);
    border-radius: var(--radius-full);
    box-shadow: 0 8px 24px var(--color-shadow-strong);
    color: var(--color-primary);
    display: flex;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-strong);
    gap: var(--space-xs);
    inset: auto;
    left: 50%;
    margin: 0;
    padding: var(--space-xs) var(--space-m);
    top: calc(env(safe-area-inset-top) + var(--space-s));
    transition:
      opacity 0.2s,
      translate 0.2s;
    translate: -50% 0;
    white-space: nowrap;

    @starting-style {
      opacity: 0;
      translate: -50% -1rem;
    }
  }

  .ring {
    animation: spin 0.9s linear infinite;
    border: 2px solid transparent;
    border-radius: var(--radius-full);
    border-top-color: currentcolor;
    height: 0.875rem;
    width: 0.875rem;
  }

  @keyframes spin {
    to {
      rotate: 1turn;
    }
  }
</style>
